__turbopack_context__.v({
  "alerts": "AlertService-module-scss-module__2X10-G__alerts",
});
